import Header from './components/Header';
import Hero from './components/Hero';
import SectionMedia from './components/SectionMedia';
import SectionApp from './components/SectionApp';
import SectionComments from './components/SectionComments';
import SectionCards from './components/SectionCards';
import SectionIndex from './components/SectionIndex';
import SectionRanking from './components/SectionRanking';
import SectionTopics from './components/SectionTopics';
import SectionContact from './components/SectionContact';
import SectionUpdates from './components/SectionUpdates';
import SectionAbout from './components/SectionAbout';
import SectionFeatures from './components/SectionFeatures';
import SectionFaq from './components/SectionFaq';
import SectionCarousel from './components/SectionCarousel';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <SectionMedia />
        <SectionApp />
        <SectionComments />
        <SectionCards />
        <SectionIndex />
        <SectionRanking />
        <SectionTopics />
        <SectionContact />
        <SectionUpdates />
        <SectionAbout />
        <SectionFeatures />
        <SectionFaq />
        <SectionCarousel />
      </main>
      <Footer />
    </div>
  );
}